// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__3T6s0","outline":"outline__2DOAe"};